module.exports = __webpack_public_path__ + "static/Hero-Archer-RX-min-360933a644839c10b86d916cc6a22cde.png";